import axios from "axios";
import { getToken } from "utils/utils";
import toast from "components/shared/toast/toast";
import { REFRESH_TOKEN } from "./apiEndpoints";
import publicRequest from "./publicRequest";

const privateRequest = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL
})


const privateRequestDotNet = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL_DOT_NET
})

const requestHandler = (request) => {
    const token = getToken() || ""
    request.headers.Authorization = `Bearer ${token}`
    return request
}

const clearToken = () => {
    localStorage.removeItem("token")
}
const responseErrorHandler = async (error) => {
    if (error?.response?.status !== 401) {
        if (error?.response?.data?.detail) {
            toast.error(error?.response?.data?.detail)
        } else {
            toast.error(error?.message)
        }

    }
    const originalRequest = error.config;
    if (false && error.response.status === 401 && !originalRequest._retry) {
        localStorage.clear()
        originalRequest._retry = true;
        try {
            const newAccessToken = await refreshAccessToken();
            if (newAccessToken) {
                originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
                return axios(originalRequest);
            }
        } catch (refreshError) {
            console.log('error', refreshError)
            toast.error(error?.message)
            // Handle refresh token failure (e.g., redirect to login)
            console.error('Refresh token error:', refreshError);
        }
    }
    return Promise.reject(error);
}
const refreshAccessToken = async () => {
    const refreshToken = localStorage.getItem('refreshToken');
    try {
        const response = await publicRequest.post(REFRESH_TOKEN, {
            refresh: refreshToken,
        });
        const newAccessToken = response.data.access;
        localStorage.setItem('token', newAccessToken);
        return newAccessToken;
    } catch (error) {
        // Handle refresh token failure (e.g., logout user)
        localStorage.clear()
    }
};
// if (error.response) {
//     const { status, data, message } = error.response

//     switch (status) {
//         case 401:
//             clearToken()
//             window.location.href = "/"
//             toast.warn("Token expired, please login")
//             break;
//         case 400:
//             toast.error(data.message ? data.message : message || "Invalid Value/ Bad Request")
//             break;
//         case 403:
//             toast.error(data.message ? data.message : message || "Access Denied/ Forbidden")
//             break;
//         case 404:
//             toast.error(data.message ? data.message : message || "Item doesn't exist")
//             break;
//         case 405:
//             toast.error(data.message ? data.message : message || "Invalid Request")
//             break;
//         case 422:
//             toast.error(data.message ? data.message : message || "Already Exists")
//             break;
//         case 504:
//             toast.error(data.message ? data.message : message || "Network Error")
//             break;
//         default:
//             toast.error(data.message ? data.message : message)
//             break;
//     }
// }
// else {
//     toast.error(error?.message)
// }
const errorHandler = (error) => {
    return Promise.reject(error)
}

privateRequest.interceptors.request.use(
    requestHandler,
    errorHandler
)

privateRequest.interceptors.response.use(
    response => response,
    responseErrorHandler
)

privateRequestDotNet.interceptors.request.use(
    requestHandler,
    errorHandler
)

privateRequestDotNet.interceptors.response.use(
    response => response,
    responseErrorHandler
)

export const privateGet = (endPoint) => {
    return privateRequest.get(`${endPoint}`)
}
export const privateGetId = (endPoint, id) => {
    return privateRequest.get(`${endPoint}/${id}`)
}

export const privatePost = (endPoint, data, config = {}) => {
    return privateRequest.post(endPoint, data, config)
}

export const privatePut = (endPoint, id, data) => {
    return privateRequest.put(`${endPoint}/${id}`, data)
}

export const privatePatch = (endPoint, id, data) => {
    return privateRequest.put(`${endPoint}/${id}`, data)
}

export const privateDelete = (endPoint, id) => {
    return privateRequest.delete(`${endPoint}/${id}`)
}

export default privateRequest
export {privateRequestDotNet}